<template>
    <el-dialog :visible.sync="visible" :title="title">
        <pre v-text="report" style="max-height: 500px"></pre>
    </el-dialog>
</template>

<script>

  export default {
    data() {
      return {
        visible: false,
        row: null,
      };
    },

    watch: {
      visible(val) {
        if (!val) {
          this.row = null;
        }
      },
    },

    computed: {
      /**
       * @return {string|null}
       */
      name() {
        return _.get(this.row, 'model.name', null);
      },

      /**
       * @return {string|null}
       */
      report() {
        return _.get(this.row, 'model.report', null);
      },

      /**
       * @return {string}
       */
      title() {
        return `Import report: "${this.name}"`;
      },
    },

    methods: {
      /**
       * @param {object} row
       */
      show(row) {
        this.row = row;
        this.visible = true;
      },
    }
  }
</script>
